<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               id='devicetype12011209'
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
               @tree-load="treeLoad"
               v-if="resetFlag"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="openAddSonType(scope.row)"
        >新增子项
        </el-button>
      </template>
      <template slot="projectSearch" slot-scope="">
        <el-select
          v-if="projectFlag"
          v-model="query.projectId"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
    <hr-dialog
      title="新增子项"
      :visible.sync="addSonFlag"
      :modal-append-to-body="false"
      width="50%"
      @close="closeAddSonDialog"
      :append-to-body='false'
      id='devicetype1211'
    >
     <template v-slot:body>
      <avue-form ref="sonForm" v-model="obj" :option="option1" label-width="100px" margin-top="0" @submit="sonSave">
          <template slot-scope="scope" slot="menuForm" >
            <el-button @click="avueExit">
              <i class="el-icon-circle-close"></i>
              取 消</el-button>
          </template>
      </avue-form>
     </template>
    </hr-dialog>
  </basic-container>

</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/crmedical/device/devicetype";
  import {mapGetters} from "vuex";
  import {treeChildren} from "@/api/crmedical/device/devicetype";
  import {getProjectList} from "@/api/crmedical/project/project";

  var inputNumber = (rule, value, callback) => {
    var regNumber = /^\+?[1-9][0-9]*$/;
    if (!regNumber.test(value)) {
      callback(new Error('请输入大于 0 的整数！'));
    } else {
      callback();
    }
  };

  var inputNumberAndLetter = (rule, value, callback) => {
    var zg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
    if (!zg.test(value)) {
      callback(new Error('请输入数字和字母组合'));
    } else {
      callback();
    }
  };
  export default {
    data() {
      return {
       
        isClickSearch:true,
        resetFlag: true,
        projectFlag: true,
        addSonFlag: false,
        obj:{},
        form: {
          projectId:''
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
           dialogClickModal:false,
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: false,
          viewBtn: true,
          selection: false,
          defaultExpandAll:false,
          lazy: true,
          rowKey: 'id',
          columnBtn: false,
          searchMenuSpan: 6,
          searchLabelWidth: 100,
          column: [
            {
              label: "项目名称",
              prop: "project",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              search: true,
              searchslot:true,
              hide: true,
              display: false,
              span: 12,
            },
            {
              label: "项目名称",
              prop: "projectId",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "change"
              }],
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              editDisabled: true,
            },
            {
              label: "类别",
              prop: "objectType",
              rules: [{
                required: true,
                message: "请选择类别",
                trigger: "change"
              }],
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=device_object_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              search: true,
            },
            {
              label: "编号",
              prop: "code",
              maxlength: 10,
              showWordLimit: true,
              overHidden: true,
              rules: [{
                required: true,
                message: "请输入编号",
                trigger: "change"
              },
                {
                  validator: inputNumberAndLetter,
                  trigger: 'blur',
                }],
            },
            {
              label: "上级类型",
              prop: "parentName",
              disabled: true,
              hide:true,
              value: '顶级节点',
              type: 'input',
            },
            {
              label: "类型名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入类型名称",
                trigger: "change"
              }],
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
              search: true,
            },
            {
              label: "排序",
              prop: "indexNo",
              rules: [
                {
                required: true,
                message: "请输入排序",
                trigger: "change"
                },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },
              ],
              maxlength: 8,
              showWordLimit: true,
            },
            {
              label: "描述",
              prop: "description",
              type: 'textarea',
              span: 24,
              rules: [{
                required: true,
                message: "请输入描述",
                trigger: "change"
              }],
              maxlength: 200,
              showWordLimit: true,
              overHidden: true
            },
          ]
        },
        option1:{
           dialogClickModal:false,
           submitText: '保 存',
          emptyBtn:false,
          column: [
            {
              label: "项目",
              prop: "projectName",
              type:'input',
              disabled: true,
            },
            {
              label: "上级类型",
              prop: "parentName",
              disabled: true,
              value: '顶级节点',
              type: 'input',
            },
            {
              label: "类别",
              prop: "objectType",
              rules: [{
                required: true,
                message: "请选择类别",
                trigger: "change"
              }],
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=device_object_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              disabled: true,
            },
            {
              label: "编号",
              prop: "code",
              maxlength: 10,
              showWordLimit: true,
              overHidden: true,
              rules: [{
                required: true,
                message: "请输入编号",
                trigger: "change"
              },
                {
                  validator: inputNumberAndLetter,
                  trigger: 'blur',
                }],
            },
            {
              label: "类型名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入类型名称",
                trigger: "change"
              }],
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "排序",
              prop: "indexNo",
              rules: [{
                required: true,
                message: "请输入排序",
                trigger: "change"
              },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },],
              maxlength: 8,
              showWordLimit: true,
            },
            {
              label: "描述",
              prop: "description",
              type: 'textarea',
              span: 24,
              rules: [{
                required: true,
                message: "请输入描述",
                trigger: "change"
              }],
              maxlength: 200,
              showWordLimit: true,
              todoListLength:10000,
            },
          ]
        },
        data: [],
        tree:{},
        treeNode:{},
        resolve:{},
        projectList: [],
        parentNode:{},
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.devicetype_add, false),
          viewBtn: this.vaildData(this.permission.devicetype_view, false),
          delBtn: this.vaildData(this.permission.devicetype_delete, false),
          editBtn: this.vaildData(this.permission.devicetype_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
     
      document.querySelectorAll('.avue-crud__dialog')[0].id = 'guiruhao20211209'
      
      this.option.height = this.bodyHeight  - 398 + 55;

            this.$nextTick(() => {
            //isClickSearch :默认设置为true
              setTimeout(()=>{
              console.log(this.$refs.crud)
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                this.isClickSearch = !this.isClickSearch
                console.log(this.isClickSearch);
                    if (this.todoListLength === 0) {
                    if (this.option.height == this.bodyHeight - 398 + 55 + (78 - 46)) {
                      this.option.height = this.bodyHeight - 287 + 1 + (78 - 46);
                    } else {
                      this.option.height = this.bodyHeight - 398 + 55 + (78 - 46);
                    }
                  } else {
                    if (this.option.height == this.bodyHeight - 398 + 55) {
                      this.option.height = this.bodyHeight - 287 + 1;
                    } else {
                      this.option.height = this.bodyHeight - 398 + 55;
                    }
                  }
                  this.$refs.crud.getTableHeight();
                });
              })
            });
    },
    methods: {
      avueExit(){
        this.addSonFlag=false
      },

      projectChange(value){
        this.projectFlag = false;
        this.query.projectId = value;
        this.query.project = value;
        setTimeout(()=>{
          this.projectFlag = true;
        },10)
      },
      closeAddSonDialog(){
        this.addSonFlag = false;
        this.$refs.sonForm.resetForm();
      },
      openAddSonType(row){
        
        console.log('bb')
        this.obj.parentName = row.name;
        this.obj.parentId = row.id;
        this.obj.objectType = row.objectType;
        this.obj.projectId = row.projectId;
        this.obj.projectName = row.$projectId;
        this.parentNode = row;
        this.addSonFlag = true;
        console.log('aa',this.$refs.sonForm)
        // console.log( document.getElementById('devicetype1211').getElementsByClassName('el-button--primary'),row);
        // let dom=document.getElementById('devicetype1211').getElementsByClassName('el-button--primary')[0].querySelector('span')
        // dom.innerHTML = '保 存'
      },
      treeLoad(tree, treeNode, resolve) {
        this.tree = tree;
        this.treeNode = treeNode;
        this.resolve = resolve;
        treeChildren({parentId:tree.id}).then((data) => {
          resolve(data.data);
        });
      },
      rowSave(row, loading, done) {
        console.log(row);
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      sonSave(row, loading, done) {
        this.resetFlag = false;
        add(row).then(() => {
          this.addSonFlag = false;
          this.$message.success('操作成功!');
          this.$refs.sonForm.resetForm();
          setTimeout(()=>{
            this.resetFlag = true;
          },50);
          loading();
        }, error => {
          this.resetFlag = true;
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        this.resetFlag = false;
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          setTimeout(()=>{
            this.resetFlag = true;
          },50)
        }, error => {
          this.resetFlag = true;
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({id: row.id});
          })
          .then(() => {
            this.resetFlag = false;
            this.onLoad();
            this.$message.success('操作成功!');
            setTimeout(()=>{
              this.resetFlag = true;
            },50)
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            if(!data.parentName){
              this.form.parentName = '顶级节点';
            }
          });
        }else{
          this.form.projectId = this.query.projectId
        }
        done();
      },
      searchReset() {
        this.query.name = '';
        this.query.objectType = '';
        this.onLoad();
      },
      searchChange(params,done) {
        // this.query = params;
        this.query.name = params.name;
        this.query.objectType = params.objectType;
        this.page.currentPage = 1;
        this.onLoad();
        console.log('searchChange');
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            console.log('111',this.todoListLength);
             this.todoListLength = data.records.length
            if(this.isClickSearch){
                   if (this.todoListLength === 0) {
                      this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
                    } else {
                      this.option.height = this.bodyHeight - 398 + 55;
                    }
                    this.$refs.crud.getTableHeight();
                }
            this.loading = false;
           
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
            console.log('222');

                this.page.total = data.total;
                this.data = data.records;
                this.todoListLength = data.records.length

                if(this.isClickSearch){
                   if (this.todoListLength === 0) {
                      this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
                    } else {
                      this.option.height = this.bodyHeight - 398 + 55;
                    }
                    this.$refs.crud.getTableHeight();
                }
                this.loading = false;
                 
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style>
  #guiruhao20211209 .el-dialog__body{
    padding-right: 24px !important;
  }
  #devicetype12011209 .avue-form__menu--center{
    text-align: right;
  }
  #devicetype1211 .el-form-item__content{
    text-align: right;
  }
</style>
